import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { GlobalContext } from "../context";

const PrivateRoute = ({ Element, ...rest }) => {
  const {
    authState: { data, loggedIn },
  } = useContext(GlobalContext);
  const user = data?.user;
  const isEmailVerified = user && !!user?.email_verified_at;

  // Token arrived but user profile not fetched yet — wait silently
  if (loggedIn && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f4f6f9]">
        <div className="w-10 h-10 border-4 border-[#d15424] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Logged in and email verified → allow through
  if (loggedIn && isEmailVerified) {
    return Element;
  }

  // Not logged in → sign in page
  return <Navigate to="/sign-in" />;
};

export default PrivateRoute;
